module.exports = __webpack_public_path__ + "img/box3-f2.42c4549b.gif";